import React from "react"
import { cn } from "../utils"

export type DrawerHeaderProps = {
  children?: React.ReactNode
  className?: string
}

const headerStyles = [
  "flex items-center justify-between gap-3 border-b border-gray-200 p-6",
  "[&>[data-slot='drawer-close']]:-mr-2"
]

/**
 * An optional header for the drawer title, close button, and arbitrary
 * content above the body with a border.
 */
export function DrawerHeader({ children, className }: DrawerHeaderProps) {
  return (
    <div data-slot="drawer-header" className={cn(headerStyles, className)}>
      {children}
    </div>
  )
}

DrawerHeader.displayName = "Drawer.Header"
